import 'reflect-metadata';
import Vue from 'vue';
import Axios from 'axios';
import vuetify from '@/plugins/vuetify';
import VueCookies from 'vue-cookies-ts';
import App from './App.vue';
import router from './router/index';
import i18n from './plugins/i18n';
import applyFilters from './plugins/filters';
import BuildDependencyContainer from './ioc/ContainerBuilder';
import { container } from 'inversify-props';
import { IAuthService, IApiService, ConstantDescriber } from './interfaces/Services';
import { socialSecurityNumberFormatter } from './utils/transformers';
import DependencyIdentifiers from './ioc/DependencyIdentifiers';

class AppBootstrap {
  async init() {
    await this.configure();
    await this.checkAuth();
    await this.loadConstants();
    this.loadApp();
  }

  /**
   * Configure various plugins and apply changes to Vue instance.
   */
  private async configure() : Promise<void> {
    BuildDependencyContainer();
    applyFilters();
    Vue.prototype.$http = Axios;
    Vue.filter('social_security_no', socialSecurityNumberFormatter);
    Vue.use(VueCookies);
    Vue.config.productionTip = false
  }

  /**
   * Applies cookie based access token to the current session.
   * @todo perform a call to the backend to check if the access token is still valid.
   */
  private async checkAuth() {
    const authService = container.get<IAuthService>(DependencyIdentifiers.AuthService);
    await authService.loadSession();
  }

  /**
   * @todo store contsts in a proper way
   */
  private async loadConstants() {
    const api = container.get<IApiService>(DependencyIdentifiers.ApiService);
    Vue.prototype.apiConstants = (await api.get('/constants') as any).data as ConstantDescriber;
  }

  /**
   * This will apply the application to the current dom and remove
   * the loader. This should be called only when everything has completely
   * loaded and checked.
   */
  private loadApp(): void {
    new Vue({
      i18n,
      vuetify,
      router,
      render: (h: any) => h(App)
    }).$mount('#app')
  }
}

const app = new AppBootstrap();
app.init().then();
export default app;
